import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Icon } from "@iconify/react";

/**
 * Image preview modal matching Sales / Add Stock pattern.
 */
export default function WhatsAppImagePreviewModal({
  show,
  imageUrl,
  alt = "Preview",
  onHide,
}) {
  if (!show || !imageUrl) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center wa-image-preview-body">
          <img
            src={imageUrl}
            alt={alt}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          <Icon icon="solar:close-circle-linear" width={16} className="me-1" />
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
